import { useState, useCallback } from 'react'
import userApi from '_api/user'
import { useModal } from '_hooks/useModal'
import UpdatesPopup from '_pages/Event/components/UpdatesPopup'

const useBlockFeatureCheck = () => {
  const updatesPopup = useModal()
  const [blockStatus, setBlockStatus] = useState(null)

  const checkAndProceed = useCallback(async (onAllowed) => {
    try {
      const { msgResp } = await userApi.checkUserBlockFeature()

      if (msgResp?.isBlockFeature) {
        setBlockStatus(msgResp?.status)
        updatesPopup.openModal()
        return
      }

      await onAllowed?.()
    } catch (error) {
      console.error('Check block feature error:', error)
      await onAllowed?.()
    }
  }, [])

  const BlockPopup = (
    <UpdatesPopup
      isOpen={updatesPopup.isOpen}
      onClose={updatesPopup.closeModal}
      blockStatus={blockStatus}
      onBlockStatusChange={setBlockStatus}
    />
  )

  return { checkAndProceed, BlockPopup }
}

export default useBlockFeatureCheck
